import { getQueryString } from '../utils';
import { queryStringParse } from 'dna-core/components/utils/js/queryString';

const qs = queryStringParse(location.search);

export const setRoute = (updateRoute, router, queries = qs) => {
	return updateRoute ?
		route => updateRoute(route, getQueryString(queries, 'iamUrl')) :
		route => router.push(route + getQueryString(queries, 'iamUrl'));
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/router/utils.js